import React, { useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";

export default function ProfileTab() {
  const [image, setImage] = useState(null);

  return (
    <>
      <h5>Profile Settings</h5>

      <div className="upload-box d-flex align-items-center gap-3">
        <div className="upload-circle">
          {image ? <img src={image} alt="" /> : "📷"}
        </div>

        <div>
          <p className="fw-semibold">Profile Photo</p>
          <small>Recommended 40px x 40px</small>

          <div className="mt-2">
            <label className="btn btn-orange btn-sm me-2">
              Upload
              <input
                type="file"
                hidden
                onChange={(e) =>
                  setImage(URL.createObjectURL(e.target.files[0]))
                }
              />
            </label>

            <Button size="sm" variant="light" onClick={() => setImage(null)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>

      <Form className="mt-4">
        <Row>
          <Col md={6}><Form.Control placeholder="First Name" /></Col>
          <Col md={6}><Form.Control placeholder="Last Name" /></Col>
          <Col md={6}><Form.Control placeholder="Email" /></Col>
          <Col md={6}><Form.Control placeholder="Phone" /></Col>
        </Row>

        <hr />

        <h6>Address Information</h6>

        <Row>
          <Col md={12}><Form.Control placeholder="Address" /></Col>
          <Col md={6}><Form.Select><option>Select</option></Form.Select></Col>
          <Col md={6}><Form.Select><option>Select</option></Form.Select></Col>
          <Col md={6}><Form.Select><option>Select</option></Form.Select></Col>
          <Col md={6}><Form.Control placeholder="Postal Code" /></Col>
        </Row>

        <div className="text-end mt-3">
          <Button variant="light">Cancel</Button>
          <Button className="btn-orange ms-2">Save</Button>
        </div>
      </Form>
    </>
  );
}